import { INVOICE_PATH_2, QUOTE_PATH, STATUSPAGE_PATH_2 } from '@atlassian/cssxp-typescommon';
import { EntityType } from '@css-xp/apd-common';

export const getEntityTypeUrl = (
  entityType?: string | undefined | null,
  entityNumber?: string | undefined | null,
  entityId?: string | undefined | null
) => {
  if (!entityType || !entityNumber) return '';
  let url = '';
  switch (entityType) {
    case EntityType.INVOICE:
      url = `${INVOICE_PATH_2}/${entityNumber}`;
      break;
    case EntityType.ENTITLEMENT:
      url = `${STATUSPAGE_PATH_2}/${entityNumber}`;
      break;
    case EntityType.QUOTE:
      url = `${QUOTE_PATH}/${entityId}`;
      break;
  }
  return url;
};
